import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { PRIORITY_COLORS, fmtDate } from "@/lib/constants";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [filter, setFilter] = useState("open");
  const nav = useNavigate();
  const load = () => api.get("/tasks").then((r) => setTasks(r.data));
  useEffect(() => { load(); }, []);

  const toggle = async (t) => {
    try {
      await api.put(`/tasks/${t.id}`, { status: t.status === "Completed" ? "Open" : "Completed", completed_date: t.status === "Completed" ? null : new Date().toISOString() });
      load();
    } catch { toast.error("Could not update task. Please try again."); }
  };
  const filtered = tasks.filter((t) => filter === "all" ? true : filter === "open" ? t.status !== "Completed" : t.status === "Completed");

  return (
    <div>
      <PageHeader title="Tasks & Follow-Ups" subtitle={`${tasks.filter((t) => t.status !== "Completed").length} open tasks`}
        action={<Select value={filter} onValueChange={setFilter}><SelectTrigger className="w-40" data-testid="task-filter"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="open">Open</SelectItem><SelectItem value="completed">Completed</SelectItem><SelectItem value="all">All</SelectItem></SelectContent></Select>} />
      <div className="p-4 sm:p-6 lg:p-8">
        <div className="bg-card border border-border rounded-md divide-y divide-border">
          {filtered.map((t) => (
            <div key={t.id} className="flex items-center gap-4 p-4" data-testid={`task-item-${t.id}`}>
              <button type="button" onClick={() => toggle(t)} className="p-2 -m-1 shrink-0 rounded-md hover:bg-secondary transition-colors" aria-label={t.status === "Completed" ? "Mark task open" : "Mark task complete"} data-testid={`task-check-${t.id}`}>
                <Checkbox checked={t.status === "Completed"} className="h-5 w-5 pointer-events-none" tabIndex={-1} />
              </button>
              <button type="button" onClick={() => toggle(t)} className="flex-1 min-w-0 text-left cursor-pointer" data-testid={`task-title-${t.id}`}>
                <div className={`font-medium ${t.status === "Completed" ? "line-through text-muted-foreground" : ""}`}>{t.task_name || "Untitled Task"}</div>
                <div className="text-xs text-muted-foreground">{t.task_type} · Due {fmtDate(t.due_date)}</div>
              </button>
              <Badge variant="outline" className={PRIORITY_COLORS[t.priority]}>{t.priority}</Badge>
              {t.lead_id && <Button size="sm" variant="ghost" onClick={() => nav(`/leads/${t.lead_id}`)} data-testid={`task-lead-${t.id}`}>Open Lead</Button>}
            </div>
          ))}
          {filtered.length === 0 && <div className="p-10 text-center text-muted-foreground">No tasks.</div>}
        </div>
      </div>
    </div>
  );
}
